/**
 * Handles 5 scenarios:
 * 1. 0 by itself or an empty string.
 * 2. a and b:
 *  a. First character 0, then the decimal seperator, then 0-9 up to 2 times.
 *  b. First character decimal seperator, then 0-9 up to 2 times.
 * 3. First character 1-9, then 0-9 up to 6 times, then the decimal seperator, then 0-9 up to 2 times.
 * 4. First character 1-9, then 0-9 up to 8 times.
 */
const scenarioOne = '(^0?$)';
const scenarioTwo = (d: string) => `(^0?[${d}][0-9]{0,2}$)`;
const scenarioThree = (d: string) => `(^[1-9][0-9]{0,6}[${d}]?[0-9]{0,2}$)`;
const scenarioFour = '(^[1-9][0-9]{0,8}$)';

/**
 * 1. Ensure the stake is a number.
 * 2. Ensure the stake does not start with two zeros.
 * 3. Ensure the stake is limited to 9 characters.
 * 4. Ensure the decimal seperators are used in the right places.
 * 5. Ensure if there is the decimal sepertor that only 2 digits are after it.
 * @see {@link https://regex101.com/r/JBBAqv/3}
 */
export const getStakeInputRegex = (decimalSeparator: '.' | ',' | string) => {
  const d = `${decimalSeparator !== '.' ? decimalSeparator : ''}.`;

  return new RegExp(`${scenarioOne}|${scenarioTwo(d)}|${scenarioThree(d)}|${scenarioFour}`, 'i');
};
